import { useStatsigClient } from '@statsig/react-bindings';
import { useEffect, useMemo } from 'react';
import { dataLayer, GtmEvent } from '../../tracking';
import { resolveStatsigExperimentOrGate, transformExperimentToVariant, transformGateToVariant } from '../helpers';
const trackedExposures = new Set();
const useVariant = (key, options) => {
  const statsigClient = useStatsigClient();
  const disableExposureLog = options === null || options === void 0 ? void 0 : options.disableExposureLog;
  const userPersistedValues = options === null || options === void 0 ? void 0 : options.userPersistedValues;
  const resolved = useMemo(() => resolveStatsigExperimentOrGate(statsigClient, key, {
    disableExposureLog,
    userPersistedValues
  }), [disableExposureLog, key, statsigClient, userPersistedValues]);
  const variant = useMemo(() => resolved.type === 'feature-gate' ? transformGateToVariant(resolved) : transformExperimentToVariant(resolved), [resolved]);
  const shouldTrack = !!(options !== null && options !== void 0 && options.trackExposure) && !disableExposureLog;
  const isRecognized = resolved.details.reason.includes(':Recognized');
  const groupName = resolved.type === 'feature-gate' ? String(resolved.value) : resolved.groupName;
  useEffect(() => {
    if (!shouldTrack || !isRecognized || !groupName) return;
    const exposureKey = `${key}:${groupName}`;
    if (trackedExposures.has(exposureKey)) return;
    trackedExposures.add(exposureKey);
    dataLayer.push({
      event: GtmEvent.StatsigExperimentGroupAssigned,
      experiment: {
        experimentId: key,
        groupName
      }
    });
  }, [groupName, isRecognized, key, shouldTrack]);
  return variant;
};
export default useVariant;